/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["check-in-filter-bookings[_ngcontent-%COMP%]:after{content:\"\";clear:both;display:block}.errorSection[_ngcontent-%COMP%]{color:#00c853}"];
export { styles as styles };
